import { AxiosResponse } from "axios";
import { Client, Controller, Endpoint, mapUrl } from "..";
import {
	MessagingAcceptTransferRequest,
	MessagingRejectTransferRequest,
} from "@/common/models/messagingTransfer";
import { InitiateTransferRequest } from "@/common/types/transfer";
import { TransferDestination } from "@/components/organisms/interactionTransferToIvr/types";
import { TransferStartResponse } from "@/common/types";
import { AssignInteractionRequest } from "../models/assignInteraction";

export const acceptGeneric = (messagingId: string): Promise<AxiosResponse> => {
	const url = mapUrl(Controller.Generics, messagingId, Endpoint.Accept);

	return Client.instance.post(url);
};

export const rejectGeneric = (messagingId: string): Promise<AxiosResponse> => {
	const url = mapUrl(Controller.Generics, messagingId, Endpoint.Reject);

	return Client.instance.post(url);
};

export const closeGeneric = (messagingId: string): Promise<AxiosResponse> => {
	const url = mapUrl(Controller.Generics, messagingId, Endpoint.Close);

	return Client.instance.post(url);
};

export const transferGeneric = (
	data: InitiateTransferRequest
): Promise<TransferStartResponse> => {
	const url = mapUrl(Controller.Generics, Endpoint.MessagingTransfer);

	return Client.instance.post(url, data);
};

export const transferToQueueGeneric = (
	data: InitiateTransferRequest
): Promise<TransferStartResponse> => {
	const url = mapUrl(Controller.Generics, Endpoint.MessagingTransferToQueue);

	return Client.instance.post(url, data);
};

export const acceptGenericTransfer = (
	data: MessagingAcceptTransferRequest
): Promise<AxiosResponse> => {
	const url = mapUrl(Controller.Generics, Endpoint.MessagingTransferAccept);

	return Client.instance.post(url, data);
};

export const rejectGenericTransfer = (
	data: MessagingRejectTransferRequest
): Promise<AxiosResponse> => {
	const url = mapUrl(Controller.Generics, Endpoint.MessagingTransferReject);

	return Client.instance.post(url, data);
};

export const getGenericTransferDestinations = (): Promise<
	TransferDestination[]
> => {
	const url = mapUrl(
		Controller.Generics,
		Endpoint.MessagingTransferDestinations
	);

	return Client.instance.get(url);
};

export const pickUpGeneric = (id: string): Promise<any> => {
	const url = mapUrl(Controller.Generics, Endpoint.PickUp);

	return Client.instance.post(url, id);
};

export const assignGeneric = (data: AssignInteractionRequest): Promise<any> => {
	const url = mapUrl(Controller.Generics, Endpoint.Assign);

	return Client.instance.post(url, data);
};
